import { isNotEmpty, useForm } from '@mantine/form'
import { notifications } from '@mantine/notifications'
import { POLICIES } from '@v2/commons/config'
import usePolicyVerification from '@v2/commons/hooks/policyVerification/usePolicyVerification'
import { type PersonModel } from '@v2/domains/person/types/person.types'
import { TaskPriorityEnum } from '@v2/domains/task/task.types'
import { useAppSelector } from '@v2/store/hooks'

import { useCreateEscalationMutation } from '../api/escalation.api'
import { type MutateEscalationData } from '../escalation.types'

type OnSubmit = (
  selectedItems: PersonModel['id'],
  cb: (taskId: string) => void,
) => void

const useAssignEscalation = () => {
  const { user } = useAppSelector((state) => state.user.userSession)

  const hasUpdtaeEscalationPolicy = usePolicyVerification(
    POLICIES.isUpdateEscalationEnabled,
  )
  const hasViewEscalationPolicy = usePolicyVerification(
    POLICIES.isGetEscalationsEnabled,
  )

  const [createEscalation, escalationMutationStatus] =
    useCreateEscalationMutation()

  const createEscalationForm = useForm<MutateEscalationData>({
    mode: 'uncontrolled',
    initialValues: {
      priority: TaskPriorityEnum.MEDIUM,
      service: '',
    },
    validateInputOnBlur: true,
    validate: {
      program: isNotEmpty('this field is required'),
      issue: isNotEmpty('this field is required'),
      assignedToId: isNotEmpty('this field is required'),
    },
  })

  const onSubmitForm: OnSubmit = async (personId, cb) => {
    createEscalationForm.onSubmit(async (values) => {
      const query = {
        ...values,
        personId: personId,
      }

      createEscalation(query)
        .unwrap()
        .then((response) => {
          createEscalationForm.reset()
          cb(response.id)
        })
        .catch((error) => {
          notifications.show({
            title: 'Something went wrong...',
            message: error.data.error,
            color: 'red',
          })
        })
    })()
  }
  return {
    user,
    onSubmitForm,
    hasUpdtaeEscalationPolicy,
    escalationMutationStatus: {
      isSuccess: escalationMutationStatus.isSuccess,
      isLoading: escalationMutationStatus.isLoading,
    },
    createEscalationForm,
    hasViewEscalationPolicy,
  }
}

export default useAssignEscalation
